<template>
  <div
    class="code-sheet-wrap"
    v-finger:pinch="pinchHandler"
    v-finger:press-move="pressMoveHandler"
    v-finger:double-tap="doubleTapHandler"
    @mousedown="(e) => { swipeHandler(e, 0) }"
    @mousemove="(e) => { swipeHandler(e, 1) }"
    @mouseup="(e) => { swipeHandler(e, 2) }"
    @dblclick="doubleTapHandler"
  >
    <div
      class="code-sheet-con"
      id="code-sheet-self"
      ref="codeSheetSelf"
      :style="scaleTypeStyle"
    >
      <header class="code-header">
        <span class="header-title bold">销售码单</span>
      </header>
      <header class="header-sider align-right">
        <div class="header-sider-block">
          <div class="flex">
            <p class="info-name align-left">码单编号：</p>
            <p class="flex-1">
              {{ electronicCodeData.order.orderCode | formatOrderCode }}
            </p>
          </div>
          <div class="flex">
            <p class="info-name align-left">码单生效日期：</p>
            <p class="flex-1">
              {{
                electronicCodeData.purchaser.confirmPoDetailDate | formatTime('yyyy/MM/dd HH:mm:ss')
              }}
            </p>
          </div>
        </div>
      </header>
      <section class="code-info info-block">
        <!-- 采购商 -->
        <div>
          <div class="bold info-title">
            <span v-if="isBillPaid === 'YES' && electronicCodeData.realName">
              甲方：{{electronicCodeData.realName}}({{ electronicCodeData.purchaser.purchaserName }})
            </span>
            <span v-else>
              甲方：{{ electronicCodeData.purchaser.purchaserName }}
            </span>
          </div>
          <div class="flex">
            <p class="info-name">营业地址：</p>
            <p class="padding-right-20" style="max-width: 260px">
              {{ electronicCodeData.purchaser.businessAddress }}
            </p>
          </div>
          <div class="flex">
            <p class="info-name">联系人：</p>
            <p class="padding-right-20">
              {{ electronicCodeData.purchaser.purchaserContactName }}
            </p>
          </div>
          <!-- <div class="flex">
            <p class="info-name">联系手机号码：</p>
            <p class="padding-right-20">
              {{ electronicCodeData.purchaser.purchaserContactMobilePhone }}
            </p>
          </div> -->
          <div class="flex">
            <p class="info-name">确认码单日期：</p>
            <p class="padding-right-20">
              {{ electronicCodeData.purchaser.confirmPoDetailDate | formatTime('yyyy/MM/dd') }}
            </p>
          </div>
        </div>
        <!-- 供应商 -->
        <div v-if="electronicCodeData.codeStyle === 1">
          <div class="bold info-title">
            乙方：{{ electronicCodeData.supplier.supplierName }}
          </div>
          <div class="flex">
            <p class="info-name">营业地址：</p>
            <p class="padding-right-20" style="max-width: 260px">
              {{ electronicCodeData.supplier.businessAddress }}
            </p>
          </div>
          <div class="flex">
            <p class="info-name">联系人：</p>
            <p class="padding-right-20">
              {{ electronicCodeData.supplier.supplierContactName }}
            </p>
          </div>
          <!-- <div class="flex">
            <p class="info-name">联系手机号码：</p>
            <p class="padding-right-20">
              {{ electronicCodeData.supplier.supplierContactMobile }}
            </p>
          </div> -->
          <div class="flex">
            <p class="info-name">确认码单日期：</p>
            <p class="padding-right-20">
              {{ electronicCodeData.supplier.confirmPoDetailDate | formatTime('yyyy/MM/dd') }}
            </p>
          </div>
          <div class="flex">
            <p class="info-name">账户信息：</p>
            <p class="padding-right-20">
              {{ electronicCodeData.supplier.bank }}
              {{ electronicCodeData.supplier.bankCardNumber }}
              {{ electronicCodeData.supplier.accountName }}
            </p>
          </div>
        </div>
        <!-- 服务商 -->
        <div v-if="electronicCodeData.codeStyle === 2">
          <div class="bold info-title">
            乙方：{{ electronicCodeData.facilitator.facilitatorName }}
          </div>
          <div class="flex">
            <p class="info-name">营业地址：</p>
            <p class="padding-right-20" style="max-width: 260px">
              {{ electronicCodeData.facilitator.businessAddress }}
            </p>
          </div>
          <div class="flex">
            <p class="info-name">联系人：</p>
            <p class="padding-right-20">
              {{ electronicCodeData.facilitator.facilitatorContactName }}
            </p>
          </div>
          <!-- <div class="flex">
            <p class="info-name">联系手机号码：</p>
            <p class="padding-right-20">
              {{ electronicCodeData.facilitator.facilitatorContactMobile }}
            </p>
          </div> -->
          <div class="flex">
            <p class="info-name">确认码单日期：</p>
            <p class="padding-right-20">
              {{ electronicCodeData.facilitator.confirmPoDetailDate | formatTime('yyyy/MM/dd') }}
            </p>
          </div>
        </div>
        <!-- 账期-->
        <div v-if="electronicCodeData.codeStyle === 3">
          <div class="bold info-title">
            乙方：{{ electronicCodeData.contractCompanyName }}
          </div>
          <div class="flex">
            <p class="info-name">营业地址：</p>
            <p class="padding-right-20" style="max-width: 260px">
              {{ electronicCodeData.contractCompanyAddress }}
            </p>
          </div>
          <div class="flex">
            <p class="info-name">联系人：</p>
            <p class="padding-right-20">
              {{ electronicCodeData.contractCompanyContact }}
            </p>
          </div>
          <div class="flex">
            <p class="info-name">确认码单日期：</p>
            <p class="padding-right-20">
              {{ electronicCodeData.purchaser.confirmPoDetailDate | formatTime('yyyy/MM/dd') }}
            </p>
          </div>
        </div>
        <div v-if="isBillPaid !== 'YES'" class="info-code-box">
          <img class="info-code" :src="codeUrl" v-if="codeUrl" />
        </div>
      </section>
      <div class="main">
        <table>
          <thead>
            <tr>
              <th
                v-for="(item, index) in tableTitle"
                :key="index"
                :style="{width: item.styleCss}"
              >
                {{item.name}}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in electronicCodeData.orderLineItemList">
              <tr :key="index">
                <!-- 供应商来源取值不同 -->
                <td>
                  {{ electronicCodeData.codeStyle === 1 ? item.bbCommodityCode : item.commodityCode }}
                </td>
                <td v-if="!IS_SAME_COMMODITY_INFO">{{ item.commodityName }}</td>
                <td v-if="!IS_NOT_COLOR_CLOTH">{{ item.commodityBottomCloth }}</td>
                <td>
                  {{ item.colorNumber }}
                </td>
                <td>{{ item.commoditySkuColorNumberDesc }}</td>
                <td
                  v-for="(x, index02) in 10"
                  :key="index02"
                >
                  {{ ((item.orderItemList[index02] || {}).convertedQuantity) || '' }}
                </td>
                <td>{{ item.salesDiscountQuantity }}</td>
                <td>{{ item.totalQuantity }}</td>
                <td>{{ item.saleUnit }}</td>
                <td>{{ item.salePrice }}</td>
                <td>{{ (item.totalQuantity * item.salePrice).toFixed(2) }}</td>
              </tr>
              <tr
                v-for="(x, index02) in Math.ceil(((item.orderItemList.length - 10) / 10))"
                :key="`${index02}deliverys${index}`"
              >
                <td></td>
                <td></td>
                <td></td>
                <td v-if="!IS_SAME_COMMODITY_INFO"></td>
                <td v-if="!IS_NOT_COLOR_CLOTH"></td>
                <td
                  v-for="(z, index03) in 10"
                  :key="`${index03}deliverysItem`"
                >
                  {{ ((item.orderItemList[index03 + (x * 10)] || {}).convertedQuantity) || '' }}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </template>
            <tr
              v-for="(item, index) in emptyRows"
              :key="`${index}emptyRows`"
            >
              <td
                v-for="(item02, index02)
                  in tableTotalColNumber + additionalColLen"
                :key="index02"
              >
              </td>
            </tr>
            <tr>
              <td
                :colspan="totalAmountColNumber + additionalColLen"
                class="base-style02"
              ><span>总计</span></td>
              <td
                colspan="3"
                class="base-style01"
              >总匹/件数：{{ electronicCodeData.purchaserOrder.totalShippingNumberOfStrips }}</td>
              <td
                colspan="3"
                class="base-style01"
              ><span class="base-style02">
                总数量：</span>{{ electronicCodeData.purchaserOrder.totalQuantity }}
              </td>
              <td
                colspan="4"
                class="base-style01"
              >
                <span class="base-style02">优惠小计：</span>
                {{ discountTotalAmount }}
              </td>
              <td
                colspan="5"
                class="base-style01"
              ><span class="base-style02">
                金额合计：</span>{{ totalAmount }} 元
              </td>
            </tr>
            <tr>
              <td
                :colspan="tableTotalColNumber + additionalColLen"
                class="base-style01 align-right"
              >
                <span class="base-style02">金额合计大写：</span>
                {{ totalAmount| convertCurrency }}
              </td>
              <!-- <td
                colspan="4"
                class="base-style01"
              >
                <span class="base-style02">已付金额: </span>
                {{ electronicCodeData.paymentInfo.settlementAmount || '0' }}元
              </td> -->
              <!-- <td
                :colspan="IS_NOT_COLOR_CLOTH ? 4 : 5"
                class="base-style01"
              >
                <span class="base-style02">待付金额：</span>
                {{ electronicCodeData.paymentInfo.remainingAmount || '0' }}元
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="footer">
        <!-- 账期合同条款 -->
        <div v-if="isBillPaid === 'YES'">
          <div class="flex margin-bottom-5">
            <p class="info-footer-name">一、交(提)货日期：</p>
            <p>
              <span class="border info-year">{{
                electronicCodeData.
                  supplierOrderList[0].commodityEstimateArrivalTime | formatTime('yyyy')
              }}</span>年
              <span class="border info-detail">{{
                electronicCodeData.
                  supplierOrderList[0].commodityEstimateArrivalTime | formatTime('MM')
              }}</span>月
              <span class="border info-detail">{{
                electronicCodeData.
                  supplierOrderList[0].commodityEstimateArrivalTime | formatTime('dd')
              }}</span>日

              <span>
                （乙方按照本码单约定的交货日期提供货物，不视为确认甲方已履行付款义务，甲方应按照
                本码单约定的时间向乙方支付相应款项）
              </span>
            </p>
          </div>
          <div
            class="flex margin-bottom-5"
          >
            <p class="info-footer-name">二、交货方式及交货地址：</p>
            <div
              class="flex info-express"
              v-if="electronicCodeData.deliveryInfo.deliveryMethod === DeliveryMethod['自提']"
            >
              <p class="info-express-name">
                (√)甲方自提
              </p>
              <p class="padding-right-10"></p>
              <p class="padding-right-10">
                <span>自提地址：</span>
                <span class="border info-address-detail">
                  {{ electronicCodeData.deliveryInfo.pickUpInfo.deliveryPickUpWarehouseProvince }}
                  {{ electronicCodeData.deliveryInfo.pickUpInfo.deliveryPickUpWarehouseCity }}
                  {{ electronicCodeData.deliveryInfo.pickUpInfo.deliveryPickUpWarehouseArea }}
                  {{ electronicCodeData.deliveryInfo.pickUpInfo.warehouseAddress }}
                </span>
              </p>
            </div>
            <div
              class="flex info-express"
              v-if="electronicCodeData.deliveryInfo.deliveryMethod === DeliveryMethod['快递']"
            >
              <p class="info-express-name">
                (√)乙方直送
              </p>
              <p class="padding-right-10"></p>
              <p class="padding-right-10">
                甲方收货地址：
                <span class="border info-address-detail">
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeName }}
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeProvince }}
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeCity }}
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeArea }}
                  {{ electronicCodeData.deliveryInfo.consignee.address }}
                </span>
              </p>
            </div>
            <div
              class="flex info-express"
              v-if="electronicCodeData.deliveryInfo.deliveryMethod === DeliveryMethod['第三方物流']"
            >
              <p class="info-express-name">
                (√)配送
              </p>
              <p class="padding-right-10">
                物流名称：
                <span class="border info-address-detail">
                  {{ electronicCodeData.deliveryInfo.logisticsCompany.name }}
                </span>
              </p>
              <p class="padding-right-10">
                甲方收货地址：
                <span class="border info-address-detail">
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeName }}
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeProvince }}
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeCity }}
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeArea }}
                  {{ electronicCodeData.deliveryInfo.consignee.address }}
                </span>
              </p>
            </div>
          </div>
          <div class="flex margin-bottom-5">
            <p class="info-footer-name">三、付款条件：</p>
            <div>
              (√)甲方需在【本码单生效后】【{{electronicCodeData.billRepayTime}}】日内向乙方指定账户支付本码单约定的全部货款，收款账户信息如下：
              <div>公司名称：广州文火火信息服务有限公司</div>
              <div>账号：3602001209200202990</div>
              <div>开户行：中国工商银行股份有限公司广州沙园支行</div>
            </div>
          </div>
          <div class="flex margin-bottom-5">
            <p class="info-footer-name">四、验货：</p>
            <div>
              甲方应在收到乙方提供的货物之日起【5日】内对该等货物进行检验，如验收不合格的，甲方应在收到乙方提供的货物之日起【5】日内提出质量异议，如甲方未在前述期限内提出质量异议，或已对货物进行裁剪、加工、洗涤或其他方式处理的，视为甲方确认乙方提供的货物合格。乙方应当在收到甲方提出的质量异议后【7】个工作日内，提出补救处理方案并积极与甲方协商。
            </div>
          </div>
          <div class="flex margin-bottom-5">
            <p class="info-footer-name">五、违约责任及争议解决：</p>
            <div>
              任何一方违反本码单的约定，应当承担相应的违约责任。凡因本码单引起的或与本码单有关的任何争议，由双方协商解决；协商不成时任何一方可向广州仲裁委员会申请仲裁解决，败诉方应向胜诉方承担因维权产生的包括但不限于律师费、仲裁费/诉讼费、财产保全费、执行费、鉴定费等合理费用。
            </div>
          </div>
          <div class="flex margin-bottom-5">
            <p class="info-footer-name">六、其他约定：</p>
            <div>本码单经双方在电子签系统签署或通过平台确认或一方实际履行合同义务后生效。</div>
          </div>
          <div class="flex flex-justify-between margin-bottom-5">
            <div style="width: 50%">
              采购商签署：
            </div>
            <div style="width: 50%">
              供应商签署：
            </div>
          </div>
        </div>

        <!-- 其他 -->
        <div v-else>
          <div class="flex margin-bottom-5">
            <p class="info-footer-name">一、交(提)货日期：</p>
            <p>
              <span class="border info-year">{{
                electronicCodeData.
                  supplierOrderList[0].commodityEstimateArrivalTime | formatTime('yyyy')
              }}</span>年
              <span class="border info-detail">{{
                electronicCodeData.
                  supplierOrderList[0].commodityEstimateArrivalTime | formatTime('MM')
              }}</span>月
              <span class="border info-detail">{{
                electronicCodeData.
                  supplierOrderList[0].commodityEstimateArrivalTime | formatTime('dd')
              }}</span>日
            </p>
          </div>
          <div
            class="flex margin-bottom-5"
          >
            <p class="info-footer-name">二、交货方式及交货地址：</p>
            <div
              class="flex info-express"
              v-if="electronicCodeData.deliveryInfo.deliveryMethod === DeliveryMethod['自提']"
            >
              <p class="info-express-name">
                (√)甲方自提
              </p>
              <p class="padding-right-10"></p>
              <p class="padding-right-10">
                <span>自提地址：</span>
                <span class="border info-address-detail">
                  {{ electronicCodeData.deliveryInfo.pickUpInfo.deliveryPickUpWarehouseProvince }}
                  {{ electronicCodeData.deliveryInfo.pickUpInfo.deliveryPickUpWarehouseCity }}
                  {{ electronicCodeData.deliveryInfo.pickUpInfo.deliveryPickUpWarehouseArea }}
                  {{ electronicCodeData.deliveryInfo.pickUpInfo.warehouseAddress }}
                </span>
              </p>
            </div>
            <div
              class="flex info-express"
              v-if="electronicCodeData.deliveryInfo.deliveryMethod === DeliveryMethod['快递']"
            >
              <p class="info-express-name">
                (√)乙方直送
              </p>
              <p class="padding-right-10"></p>
              <p class="padding-right-10">
                甲方收货地址：
                <span class="border info-address-detail">
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeName }}
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeProvince }}
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeCity }}
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeArea }}
                  {{ electronicCodeData.deliveryInfo.consignee.address }}
                </span>
              </p>
            </div>
            <div
              class="flex info-express"
              v-if="electronicCodeData.deliveryInfo.deliveryMethod === DeliveryMethod['第三方物流']"
            >
              <p class="info-express-name">
                (√)配送
              </p>
              <p class="padding-right-10">
                物流名称：
                <span class="border info-address-detail">
                  {{ electronicCodeData.deliveryInfo.logisticsCompany.name }}
                </span>
              </p>
              <p class="padding-right-10">
                甲方收货地址：
                <span class="border info-address-detail">
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeName }}
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeProvince }}
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeCity }}
                  {{ electronicCodeData.deliveryInfo.consignee.consigneeArea }}
                  {{ electronicCodeData.deliveryInfo.consignee.address }}
                </span>
              </p>
            </div>
          </div>
          <div class="flex margin-bottom-5">
            <p class="info-footer-name">三、付款条件：</p>
            <div>
              (√)款到发货，甲方在本码单签订后<span class="border info-detail">1</span>个工作日内，向乙方一次性支付所有货款
            </div>
          </div>
          <div class="flex margin-bottom-5">
            <p class="info-footer-name">四、验货：</p>
            <div>
              甲方应在收到乙方提供的货物之日起【7个工作日】内对该等货物进行检验，
              如验收不合格的，甲方应在收到乙方提供的货物之日起【5】日内提出质量异议，
              如甲方未在前述期限内提出质量异议，或已对货物进行裁剪、加工、洗涤或其他方式处理的，
              视为甲方确认乙方提供的货物合格。乙方应当在收到甲方提出的质量异议后【7】个工作日内，
              提出补救处理方案并积极与甲方协商。
            </div>
          </div>
          <div class="flex margin-bottom-5">
            <p class="info-footer-name">五、违约责任及争议解决：</p>
            <div>
              任何一方违反本码单的约定，应当承担相应的违约责任。凡因本码单引起的或与本码单有关的任何争议，
              由双方协商解决；协商不成时任何一方可向本码单的履行地人民法院提起诉讼
            </div>
          </div>
          <div class="flex margin-bottom-5">
            <p class="info-footer-name">六、其他约定：</p>
            <div>本码单经双方系统确认或一方实际履行合同义务后生效。</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getNewQrCodeContent,
} from '@/api/baibu';
import NP from 'number-precision';
import QRCode from 'qrcode';
import { browser } from '@/utils/browser';

const DeliveryMethod = {
  第三方物流: 'SEND_BY_THIRD',
  快递: 'SEND_BY_EXPRESS',
  自提: 'SEND_BY_SELF_TAKE',
};
const CategoryNo1 = {
  净色: 'CATEGORY_NO1_1',
  花型: 'CATEGORY_NO1_2',
};
export default {
  name: 'CodeSheet',
  props: {
    electronicCodeData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    scaleType: {
      type: String,
      default: 'NO',
    },
    isNewOrder: {
      type: String,
      default: 'NO',
    },
    orderCode: {
      type: String,
      default: '',
    },
    orderId: {
      type: String,
      default: '',
    },
    workerId: {
      type: String,
      default: '',
    },
    isBillPaid: {
      type: String,
      default: 'NO',
    },
  },
  filters: {
    formatOrderCode(val) {
      if (!val) return '';
      let returnStr = (val).replace(/()(\d{4})/g, '$1-$2');
      returnStr = returnStr.indexOf('-') === 0 ? returnStr.slice(1) : returnStr;
      return returnStr;
    },
  },
  data() {
    return {
      browser,
      totalAmountColNumber: 3,
      tableTotalColNumber: 18,
      clientWidth: document.body.clientWidth,
      clientHeight: window.screen.height,
      conClientWidth: 0,
      conClientHeight: 0,
      curScale: 0,
      scale: 1,
      deltaY: 0,
      deltaX: 0,
      origin: '0 0',
      scaleTypeStyle: '',
      DeliveryMethod,
      CategoryNo1,
      codeUrl: '',
      IS_NOT_COLOR_CLOTH: true,
      IS_SAME_COMMODITY_INFO: false,
      tableTitle: [
        // { styleCss: '95px', name: '商品编码' },
        { styleCss: '10%', name: '货号编码' },
        { styleCss: '8%', name: '色号' },
        { styleCss: '8%', name: '颜色' },
        { styleCss: '5%', name: '1' },
        { styleCss: '5%', name: '2' },
        { styleCss: '5%', name: '3' },
        { styleCss: '5%', name: '4' },
        { styleCss: '5%', name: '5' },
        { styleCss: '5%', name: '6' },
        { styleCss: '5%', name: '7' },
        { styleCss: '5%', name: '8' },
        { styleCss: '5%', name: '9' },
        { styleCss: '5%', name: '10' },
        { styleCss: '9%', name: '优惠数量' },
        { styleCss: '6%', name: '数量' },
        { styleCss: '5%', name: '单位' },
        { styleCss: '5%', name: '单价' },
        { styleCss: '8%', name: '金额' },
      ],
      products: [], // 订单商品信息
      orderInfo: {
        factoryName: '', // 客户公司
        paymentMethod: '', // 货款类型
        orderId: '', // 订单编号
        buyerName: '', // 客户名称
        buyerMobile: '', // 客户电话
        logisticsName: '', // 物流名称
        createTime: null, // 下单时间
        codeDesc: '', // 备注
        workerName: '', // 业务员
        realMoney: null, // 订单总额
        operator: '', // 经手人
        guiderBbCode: '', // 经手人code

        // 2020-04-02 电子码单修改新加的
        shipType: '', // 配送类型
        consigneeAddress: '', // 收货地址
        consignee: '', // 收货人
        consigneeMobile: '', // 收货电话
        wareHouseName: '', // 仓库名称
        wareHouseAddr: '', // 仓库地址
      },
      buyerReceipt: {
        shouldReceipt: null, // 实收金额
        noReceipt: null, // 待收金额
      },
      sleep: false,
      isMouseMove: false,
      mouseData: {
        x: 0,
        y: 0,
      },
    };
  },

  created() {},

  watch: {
    sleep(val) {
      if (val) {
        setTimeout(() => {
          this.sleep = false;
        }, 300);
      }
    },
    scaleType: {
      handler() {
        this.doubleTapHandler();
      },
      immediate: true,
    },
    orderCode: {
      handler() {
        // 花型
        this.IS_NOT_COLOR_CLOTH = CategoryNo1['净色'] === (this.electronicCodeData.orderLineItemList ?? [])[0]?.categoryNo1;
        if (!this.IS_NOT_COLOR_CLOTH) {
          this.tableTitle.splice(1, 0, { styleCss: '76px', name: '底布' });
        }

        // 判断是否展示品名
        // 货号 commodityNumber
        // 品名 commodityName

        if (!this.IS_SAME_COMMODITY_INFO) {
          // 当【货号】与【品名】信息不一致（不一致：全文本比对）时，展示；否则，隐藏该列
          this.tableTitle.splice(1, 0, { styleCss: '76px', name: '品名' });
        }

        this.getQrCodeContent();
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize, false);
  },
  mounted() {
    this.clientWidth = document.body.clientWidth;
    this.clientHeight = window.screen.height;
    window.addEventListener('resize', this.handleResize, false);
  },
  computed: {
    totalAmount() {
      // const totalAmount = (this.electronicCodeData.purchaserOrder?.totalAmount || 0);
      // return this.discountTotalAmount === '-' ? totalAmount : ((totalAmount) - (this.discountTotalAmount || 0)).toFixed(2);
      return ((this.electronicCodeData.purchaserOrder?.totalAmount || 0) - (this.discountTotalAmount || 0)).toFixed(2);
    },
    discountTotalAmount() {
      const {
        purchaserOrder,
      } = this.electronicCodeData;
      return ((purchaserOrder?.manualDiscountAmount || 0) + (purchaserOrder?.systemDiscountAmount || 0)).toFixed(2);

      // const {
      //   purchaserOrder,
      // } = this.electronicCodeData;
      // const discount = ((purchaserOrder?.manualDiscountAmount || 0)
      //   + (purchaserOrder?.systemDiscountAmount || 0));
      // return discount <= 1 && discount >= -1 ? discount.toFixed(2) : '-';
    },

    additionalColLen() {
      // 附加列数
      return Number(!this.IS_SAME_COMMODITY_INFO) + Number(!this.IS_NOT_COLOR_CLOTH);
    },
    // 已付金额
    payment() {
      return NP.strip(this.buyerReceipt.shouldReceipt - this.buyerReceipt.noReceipt);
    },

    // 保证表格最少6行内容
    emptyRows() {
      let rows = 6;
      this.electronicCodeData.orderLineItemList.forEach((p) => {
        rows -= Math.ceil(p.orderItemList.length / 5);
      });
      return rows < 0 ? 0 : rows;
    },

    // 总匹/件数
    deliveryCount() {
      let deliveryCount = 0;
      this.products.forEach((obj) => {
        deliveryCount += obj.deliveryCount;
      });
      return deliveryCount;
    },

    // 总数量
    productAmount() {
      let productAmount = 0;
      this.products.forEach((obj) => {
        productAmount += obj.productAmount * 1000;
      });
      return productAmount / 1000;
    },
  },

  // components: {Header},

  methods: {
    handleResize() {
      this.getConSize();
      this.renderScale();
    },
    getConSize() {
      this.conClientWidth = 800 * this.curScale;
      this.conClientHeight = 800 * this.curScale;
    },
    renderScale(transitionStyle) {
      const {
        scale,
        deltaY,
        deltaX,
        origin,
      } = this;
      const curScale = (this.scaleType === '1' ? this.clientWidth / 800 : 1) * scale;
      /* eslint-disable */
      this.scaleTypeStyle = `
      transform-origin: ${origin};
      -ms-transform-origin: ${origin};
      -webkit-transform-origin: ${origin};
      -moz-transform-origin: ${origin};
      -o-transform-origin: ${origin};
      transform: translate3d(${-1 * deltaX}px, ${-1 * deltaY}px, 0) scale(${curScale}, ${curScale});
      -ms-transform: translate3d(${-1 * deltaX}px, ${-1 * deltaY}px, 0) scale(${curScale}, ${curScale});
      -moz-transform: translate3d(${-1 * deltaX}px, ${-1 * deltaY}px, 0) scale(${curScale}, ${curScale});
      -webkit-transform: translate3d(${-1 * deltaX}px, ${-1 * deltaY}px, 0) scale(${curScale}, ${curScale});
      -o-transform: translate3d(${-1 * deltaX}px, ${-1 * deltaY}px, 0) scale(${curScale}, ${curScale});
      ${transitionStyle}`;
      /* eslint-disable */
      this.curScale = curScale;
    },
    swipeHandler(e, status) {
      if (status === 0) {
        // 点击
        this.isMouseMove = !(this.browser.mobile || this.browser.android || this.browser.ios);
        this.mouseData = {
          x: e.offsetX,
          y: e.offsetY,
        };
        return;
      }
      if (status === 1) {
        // 拖动
        const {
          movementX,
          movementY,
        } = e;
        if (!this.isMouseMove || !movementX || !movementY) {
          return;
        }
        this.pressMoveHandler({ deltaX: movementX, deltaY: movementY });
        return;
      }
      if (status === 2) {
        // 松开
        this.isMouseMove = false;
        return;
      }
    },
    doubleTapHandler() {
      this.deltaY = 0;
      this.deltaX = 0;
      this.scale = 1;
      this.origin = '0 0';
      this.renderScale();
      this.getConSize();
    },
    pressMoveHandler({ deltaX, deltaY }) {
      // || this.scaleType === '2'
      if (this.sleep) {
        return;
      }
      this.deltaY = this.deltaY - (deltaY * 1.5);
      this.deltaX = this.deltaX - (deltaX * 1.5);
      let transitionStyle = '';
      if (this.conClientWidth - this.deltaX < 80 || this.deltaX + this.clientWidth < 80) {
        this.deltaX = this.deltaX / 1.2;
        transitionStyle += `
        transition: transform .3s linear;
        -moz-transition: transform .3s linear;
        -webkit-transition: transform .3s linear;
        -o-transition: transform .3s linear;`;
        this.sleep = true;
      }
      if (this.deltaY + this.clientHeight < 200 || this.conClientHeight - this.deltaY < 100) {
        this.deltaY = this.deltaY / 1.4;
        transitionStyle += `
        transition: transform .3s linear;
        -moz-transition: transform .3s linear;
        -webkit-transition: transform .3s linear;
        -o-transition: transform .3s linear;`;
        this.sleep = true;
      }
      this.renderScale(transitionStyle);
    },
    pinchHandler({ scale, zoom }) {
      // if (this.scaleType === '2') {
      //   return;
      // }
      // screenX radiusX , changedTouches: [{ clientX, clientY }]
      if (this.scale <= 3 && this.scale >= 0.3) {
        // this.origin = `${clientX}px ${clientY}px`;
        this.scale = this.scale + ((0.1) * (scale || zoom > 1 ? 0.15 : -0.15));
        this.getConSize();
        this.renderScale();
      } else {
        this.scale = this.scale > 3 ? 3 : 0.3;
      }
    },
    async getQrCodeContent() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '码单生成中，请稍候...',
      });
      try {
        const { data } = await getNewQrCodeContent({
          orderId: this.orderId,
          orderCode: this.orderCode,
          printType: 'BAIBU_ORDER',
          workerId: this.workerId,
          isNewOrder: this.isNewOrder,
        });
        if (data) {
          const { contentType, content } = data;
          if (contentType !== 'APPLET_CODE') {
            await this.creatQrCode(content);
          } else {
            this.codeUrl = content;
          }
        } else {
          await this.creatQrCode(this.orderId);
        }
      } catch (e) {
        await this.creatQrCode(this.orderId);
      } finally {
        this.$toast.clear();
        this.$nextTick(() => {
          this.$emit('success');
        });
      }
    },
    async creatQrCode(content) {
      this.codeUrl = await QRCode.toDataURL(content);
    },
  },
};
</script>

<style scoped lang="scss">
.bold {
  font-weight: 700;
}
.align-left {
  text-align: left;
}
.align-right {
  text-align: right;
}
.inline-block {
  display: inline-block;
}
.flex-1 {
  flex: 1;
}
.flex {
  display: flex;
  @extend .flex-1
}
.border {
  border-bottom: 1PX solid #333;
}


.code-sheet-con {
  width: 800PX;
  font-family: Microsoft YaHei, simsun, "宋体", sans-serif;
  padding: 40PX 20PX;
  font-size: 12PX;
  transition: transform 0 linear;
  // &.origin-scale {
  //   width: 800PX;
  // }
}
.code-header {
  position: relative;
  text-align: center;
}
.header-title {
  font-size: 40PX;
}
.header-sider {
  margin-top: -25PX;
  margin-bottom: 20PX;
  line-height: 16PX;
}
.header-sider-block {
  display: inline-block;
}
.header-sider-left {
  min-width: 90PX;
}

// 甲乙方信息
.code-info {
  position: relative;
  justify-content: space-between;
  margin-top: 20PX;
}
.info-block {
  display: flex;
  line-height: 24PX;
}
.info-title {
  font-size: 13PX;
}
.info-name {
  max-width: 90PX;
}
.info-code-box, .info-code {
  width: 120PX;
  height: 120PX;
  align-self: flex-end;
}

// @media screen and (max-width: 650px) {
//   .header-sider {
//     margin-top: 10PX;
//     margin-bottom: 20PX;
//   }
// }

// 表格
.main {
  margin-top: 20PX;
  table{
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: 1PX solid #000;
    max-width: 100%;
    background-color: transparent;
    table-layout: fixed;
    empty-cells: show;
      tr{
        th{
          height: 20PX;
          vertical-align: middle;
          padding: 2PX 3PX;
          vertical-align: top;
          border-right: 1PX solid #000;
          border-top: none;
          border-bottom: none;
          text-align: left;
          font-weight: bold;
          word-break: break-all;
          &:nth-last-child(1){
            border-right: none;
          }
        }
        td{
          padding: 2PX 3PX;
          border: 1PX solid #000;
          border-left: none;
          border-bottom: none;
          height: 21PX;
          word-break: break-all;
          &:nth-last-child(1){
            border-right: none;
          }
        }
      }
    }
  }

  .footer {
    margin-top: 40PX;
    line-height: 20PX;
  }
  .info-year {
    padding: 0 20PX;
  }
  .info-detail {
    padding: 0 15PX;
  }
  .info-address-detail {
    padding: 0 15PX;
    &:empty {
      padding: 0 40PX;
    }
  }
  .info-footer-name {
    min-width: 150PX;
  }
  .info-express {
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .info-express-name {
    min-width: 70PX;
  }
  .info-detail-block {
    display: inline-block;
  }
  // .footer{
  //   &-main{
  //     display: flex;
  //     height: 20PX;
  //     line-height: 20PX;
  //     &_i{
  //       flex: 1;
  //     }
  //   }
  //   p{
  //     margin: 10PX 0 0;
  //     line-height: 16PX;
  //   }
  // }
</style>
